import { render, staticRenderFns } from "./StoreOverviewApp.vue?vue&type=template&id=4a2700d0&scoped=true"
import script from "./StoreOverviewApp.vue?vue&type=script&lang=js"
export * from "./StoreOverviewApp.vue?vue&type=script&lang=js"
import style0 from "./StoreOverviewApp.vue?vue&type=style&index=0&id=4a2700d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2700d0",
  null
  
)

export default component.exports